import { render, staticRenderFns } from "./VoteExpiredModal.vue?vue&type=template&id=94bf0c7c&"
import script from "./VoteExpiredModal.vue?vue&type=script&lang=js&"
export * from "./VoteExpiredModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports